<template>
  <div class="sales-page">
    <app-page-header title="Vendas">
      <button @click="importSales()" v-app-button.icon-left>
        <b-icon size="is-small" icon="upload" />IMPORTAR
      </button>
      <button
        @click="onExportClicked()"
        :disabled="isExporting"
        class="export-btn"
        v-app-button.icon-left
      >
        <b-icon size="is-small" icon="download" />EXPORTAR
      </button>
    </app-page-header>

    <sales-table ref="salesTable"></sales-table>

    <b-modal
      :active.sync="showModal"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
    >
      <sale-import-modal @success="onImportSuccess"></sale-import-modal>
    </b-modal>
  </div>
</template>

<script>
import SaleService from '@/services/sale.service';
import SalesTable from '@/components/Tables/SalesTable.vue';
import SaleImportModal from '@/components/Modals/SaleImportModal.vue';

export default {
  name: 'sales-page',
  components: {
    SalesTable,
    SaleImportModal,
  },
  data: () => {
    return {
      showModal: false,
      isExporting: false,
    };
  },
  methods: {
    importSales() {
      this.showModal = true;
    },
    onExportClicked() {
      const {
        family,
        term,
        end_date,
        import_id,
        start_date,
        network_id,
      } = this.$refs.salesTable.requestFilters;

      if (family || term || end_date || import_id || start_date || network_id) {
        this.exportSales();
        return;
      }

      this.$buefy.dialog.alert({
        title: 'Impossível exportar todas as vendas',
        message: 'Você precisa aplicar algum filtro para exportar as vendas!',
        confirmText: 'Entendi',
      });
    },
    exportSales() {
      this.isExporting = true;

      const filters = this.$refs.salesTable.requestFilters;

      SaleService.export(filters)
        .then(({ data }) => {
          const link = document.createElement('a');
          link.target = '_blank';
          link.href = data.url;
          link.click();
        })
        .catch(({ response }) => {
          this.toastify(
            response.data.message || 'Erro ao realizar exportação.',
            'error'
          );
        })
        .finally(() => (this.isExporting = false));
    },
    onImportSuccess() {
      this.$router.push({ name: 'imports.index' });
    },
  },
};
</script>

<style lang="scss" scoped>
button.export-btn:disabled {
  cursor: progress;
}
</style>
